import React from "react";
import { map } from "lodash";
import styled from "styled-components";
import { form } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import { tr } from "@radarly/i18n";
import { Status } from "@radarly/models/filters";

interface IProps {
  selectors: Status[];
  onSelect: (status: Status, category?: string) => void;
  locale?: Locale;
  category?: string;
  className?: string;
}

const Root = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

const Selector = styled.div`
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
  margin-right: 12px;
  color: ${form};
`;

const FilterbarPanelsGlobalSelector = ({
  selectors,
  onSelect,
  locale = Locale.English,
  category,
  className,
}: IProps) => {
  return (
    <Root className={className}>
      {map(selectors, (selector, i) => (
        <Selector key={i} onClick={() => onSelect(selector, category)}>
          {tr(locale, `FORM::${selector}_ALL`)}
        </Selector>
      ))}
    </Root>
  );
};

export default FilterbarPanelsGlobalSelector;
